import React from 'react'
import { Button } from '@mui/material'
import { FormValues, SubAdmin } from '../../../../services/types/APIRequestType'
import { formatPhoneNumber } from '../../../../utils'

interface SubAdminTableProps {
  currentItems: SubAdmin[] | undefined
  handleOpen: () => void
  setIsEdit: (isEdit: boolean) => void
  setFormValues: (values: FormValues) => void
  setSelectedId: (id: string) => void
  setIsEnabled: (isEnabled: boolean) => void
}

const SubAdminTable: React.FC<SubAdminTableProps> = ({
  currentItems,
  handleOpen,
  setIsEdit,
  setFormValues,
  setSelectedId,
  setIsEnabled,
}) => {
  return (
    <div className="responsive-table-scroll">
      <table className="table-container bg-grad before:rounded-[20px] rounded-[20px]">
        <thead>
          <tr className="table-heading row-bg1">
            <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              Name
            </th>
            <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              Phone Number
            </th>
            <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              Email Address
            </th>
            <th className="text-left whitespace-pre border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {currentItems?.map((item: SubAdmin, idx: number) => (
            <tr key={idx} className={idx % 2 === 0 ? 'rowbg2' : 'row-bg1'}>
              <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                <span className="inline-block max-w-[160px] break-words whitespace-normal text-left">
                  {item?.profileInfo?.firstName}&nbsp;
                  {item?.profileInfo?.lastName}
                </span>
              </td>
              <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                {formatPhoneNumber(
                  item?.profileInfo?.phone,
                  item?.profileInfo?.countryCode,
                )}
              </td>
              <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                {item?.email}
              </td>
              <td className="text-left border border-[#d8e4fb33] border-r border-b-[0] border-t-[0]">
                <Button
                  onClick={() => {
                    handleOpen()
                    setIsEdit(true)
                    setFormValues({
                      firstName: item?.profileInfo?.firstName,
                      lastName: item?.profileInfo?.lastName,
                      email: item?.email,
                      phone: item?.profileInfo?.phone?.toString(),
                    })
                    setSelectedId(item._id)
                    setIsEnabled(item.isAccountBlocked)
                  }}
                >
                  <img src="/icon/Edit 1.svg" alt="Edit" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SubAdminTable
